import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppShell } from '@/app/app-shell'
import { WorkplaceGate } from '@/app/workplace-gate'

/// Гейт робочого місця. Автентифікації ще немає (див. session-provider), тому
/// поки що це просто оболонка — але маршрути вже живуть за нею, і коли вхід
/// зʼявиться, жоден екран не доведеться переносити.
export const Route = createFileRoute('/_app')({
  component: () => (
    <AppShell>
      {/* Право на розділ перевіряється ТУТ, а не в кожному екрані: меню ховає
          пункт, але URL живе довше за меню (D70). */}
      <WorkplaceGate>
        <Outlet />
      </WorkplaceGate>
    </AppShell>
  ),
})
